import { render, staticRenderFns } from "./listaCupones.vue?vue&type=template&id=b0940206&scoped=true"
import script from "./listaCupones.vue?vue&type=script&lang=js"
export * from "./listaCupones.vue?vue&type=script&lang=js"
import style0 from "./listaCupones.vue?vue&type=style&index=0&id=b0940206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0940206",
  null
  
)

export default component.exports